/** CH315 功能实现使用的稳定 Flash 布局。 */
export const CH315_FEATURE_LAYOUT = {
  keyCount: 96,
  configCount: 4,
  configBase: 0x10002000,
  configStride: 0x5000,
  layerStride: 0x1000,
  configNameOffset: 0x03ec,
  configPerfOffset: 0x000c,
  dynamicLightingOffset: 0x0010,
  sideLightingOffset: 0x0054,
  rtBitmapOffset: 0x00e0,
  rtTriggerOffset: 0x00ec,
  rtResetOffset: 0x01ac,
  absoluteTriggerOffset: 0x026c,
  bottomDeadZoneOffset: 0x032c,
  basicInfoReportRateAddress: 0x0018,
  macroBase: 0x10020000,
  macroStride: 0x0200,
  macroNameBase: 0x1002c000,
  macroCount: 96,
  macroNameBytes: 16,
} as const

export type CH315LayerIndex = 0 | 1 | 2 | 3

/** F0/01 用户状态在公共设备对象上的强类型表示。 */
export interface ch315DeviceCustom {
  conProtocol: number
  cfgSel: number
  blMode: number
  blLevel: number
  blSpeed: number
  blColor: number
  sleepTime: number
  rpt: number
  batPercent: number
  batStatus: 0 | 1 | 2 | 3
  functionWord: number
  usbPid: number
  deviceStatus: number
  rfConnected: 0 | 1
  rfRssi: number
  sideLightMode: number
  sideLightLevel: number
  sideLightSpeed: number
  sideLightColor: number
}

export function getCH315ConfigBase(index: number): number {
  return CH315_FEATURE_LAYOUT.configBase + index * CH315_FEATURE_LAYOUT.configStride
}

export function getCH315LayerBase(configIndex: number, layer: CH315LayerIndex): number {
  return getCH315ConfigBase(configIndex) + (layer + 1) * CH315_FEATURE_LAYOUT.layerStride
}
